import React from 'react';
import { TOpsUserInfo } from 'types/operation';
import { getOpsMemberList } from 'api/access';

const useOpsUserList = (): [TOpsUserInfo[] | undefined, boolean, () => void] => {
    const loading = React.useRef(false);
    const [data, setData] = React.useState<TOpsUserInfo[]>();
    const fetchData = async () => {
        try {
            loading.current = true;
            const result = await getOpsMemberList();
            if (!result.error) {
                setData(result.data?.data);
            }
            loading.current = false;
        } catch (e) {
            console.error(e);
            loading.current = false;
        }
    };
    React.useEffect(() => {
        if (!loading.current) {
            fetchData();
        }
    }, []);

    return [data, loading.current, fetchData];
};

export default useOpsUserList;
